import React from 'react';

import { ITransactionTabsProps } from '../types';
import { useTransactionScannedDocsTabProps } from './hooks';

const TransactionScannedDocsTab: React.FC<ITransactionTabsProps> = ({ transactionData }) => {
  const { Table } = useTransactionScannedDocsTabProps({ transaction: transactionData });
  return (
    <div className='h-full overflow-y-auto'>
      <Table />
    </div>
  );
};

export default React.memo(TransactionScannedDocsTab);
